<template>
  <FormItemSkuList
    ref="formItemSkuListRef"
    v-model="curSkulist"
    :baseItemId="baseItemId"
    :specifications="specifications"
    :tableCols="skuTableCols"
    :showBindSkuOuterId="true"
    skuOuterIdKey="outId"
    :showImgCol="showImgCol"
    @change="skuListChange"
    @batchUpdate="batchUpdateSku"
  >
    <div slot="productSkuSuggestedPriceBatchSlot">
      <InputDigitComb v-model="batchValues.productSkuSuggestedPrice.suggestedPriceStr" :format="false" :precision="10">
        <el-select
          v-model="batchValues.productSkuSuggestedPrice.suggestedPriceCurrencyType"
          slot="append"
          placeholder="请选择"
          style="width: 70px"
        >
          <el-option v-for="c in currencyList" :value="c.code" :label="c.code" :key="c.code"></el-option>
        </el-select>
      </InputDigitComb>
      <!-- <el-button type="primary" @click="batchSetVal('productSkuSuggestedPrice')" style="margin-left: 6px">确定</el-button> -->
    </div>
    <div slot="productSkuUsSuggestedPriceBatchSlot">
      <InputDigitComb v-model="batchValues.productSkuUsSuggestedPrice.suggestedPriceStr" :format="false" :precision="10">
        <el-select
          v-model="batchValues.productSkuUsSuggestedPrice.suggestedPriceCurrencyType"
          slot="append"
          placeholder="请选择"
          style="width: 70px"
        >
          <el-option v-for="c in currencyList" :value="c.code" :label="c.code" :key="c.code"></el-option>
        </el-select>
      </InputDigitComb>
    </div>
    <el-popover slot="productSkuMultiPackBatchSlot" placement="top" width="300" trigger="click">
      <el-input slot="reference" :value="productSkuMultiPackBatchSetValue" readonly  width="200px"></el-input>
      <div>
        <div>
          <el-select v-model="batchValues.productSkuMultiPack.skuClassification" placeholder="请选择" @change="v => skuClassificationChange(v, batchValues)">
            <el-option v-for="item in skuClassificationOpts" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </div>
        <div style="margin:6px 0;x">
          <span>单品数量：</span>
          <el-input-digit
            :disabled="batchValues.productSkuMultiPack.skuClassification == 1"
            v-model.number="batchValues.productSkuMultiPack.numberOfPieces"
            placeholder="请输入"
            format="#"
            style="width: 60px"
          >
          </el-input-digit>
          <el-select
            :disabled="batchValues.productSkuMultiPack.skuClassification == 3"
            v-model="batchValues.productSkuMultiPack.pieceUnitCode"
            placeholder="请选择"
            style="width: 50px"
          >
            <el-option v-for="item in pieceUnitCodeOpts" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </div>

        <div v-if="batchValues.productSkuMultiPack.skuClassification != 1">
          <el-select v-model="batchValues.productSkuMultiPack.individuallyPacked" placeholder="请选择">
            <el-option v-for="item in individuallyPackedOpts" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </div>
      </div>
    </el-popover>
    <!-- <div slot="extCodeBatchSlot">
      <el-input v-model="batchValues.extCode" placeholder="sku货号" width="180px"></el-input>
    </div> -->
    <template slot="productSkuUsSuggestedPriceHeaderSlot" slot-scope="{ col }">
      <div style="display:block;text-align:left;line-height:24px;">
        <div style="display:block;padding-left:0;;line-height:24px;">{{col.attrs.label}}<span style="color:red;" v-if="!col.attrs.noRequired">*</span></div>
        <span style="position: relative;font-size:10px;color:#ccc;top:-6px;">适用于美国</span>
      </div>
    </template>
    <template slot="productSkuBarCodeReqsSlot" slot-scope="{ row }">
        <SearchSelectComb v-model="row.productSkuWhExtAttr.productSkuBarCodeReqs[0].codeType" style="width:80px;display:block;" :items="barCodeList">
            <el-input v-model="row.productSkuWhExtAttr.productSkuBarCodeReqs[0].code" style="width:100px;" placeholder="请输入"></el-input>
        </SearchSelectComb>
    </template>
    <template slot="supplierPriceSlot" slot-scope="{ row }">
      <el-input-digit v-model.number="row.supplierPrice" placeholder="请输入" format="#.##" style="width: 80px">
        <span>￥</span>
      </el-input-digit>
    </template>
    <template slot="productSkuSuggestedPriceSlot" slot-scope="{ row }">
        <InputDigitComb v-model="row.productSkuSuggestedPrice.suggestedPriceStr" :format="false" :precision="10">
          <el-select
            v-model="row.productSkuSuggestedPrice.suggestedPriceCurrencyType"
            slot="append"
            placeholder="请选择"
            style="width: 70px"
          >
            <el-option v-for="c in currencyList" :value="c.code" :label="c.code" :key="c.code"></el-option>
          </el-select>
        </InputDigitComb>
    </template>
    <template slot="productSkuUsSuggestedPriceSlot" slot-scope="{ row }">
        <InputDigitComb v-model="row.productSkuUsSuggestedPrice.suggestedPriceStr" :format="false" :precision="10">
          <el-select
            v-model="row.productSkuUsSuggestedPrice.suggestedPriceCurrencyType"
            slot="append"
            placeholder="请选择"
            style="width: 70px"
          >
            <el-option v-for="c in currencyList" :value="c.code" :label="c.code" :key="c.code"></el-option>
          </el-select>
        </InputDigitComb>
    </template>
    <template slot="productSkuMultiPackSlot" slot-scope="{ row }">
      <div style="margin: 6px 0px">
        <el-select v-model="row.productSkuMultiPack.skuClassification" placeholder="请选择" @change="v => skuClassificationChange(v, row)">
          <el-option v-for="item in skuClassificationOpts" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </div>
      <div style="margin: 6px 0px">
        <span>单品数量：</span>
        <el-input-digit
          :disabled="row.productSkuMultiPack.skuClassification == 1"
          v-model.number="row.productSkuMultiPack.numberOfPieces"
          placeholder="请输入"
          format="#"
          style="width: 60px"
        >
        </el-input-digit>
        <el-select
          :disabled="row.productSkuMultiPack.skuClassification == 3"
          v-model="row.productSkuMultiPack.pieceUnitCode"
          placeholder="请选择"
          style="width: 50px"
        >
          <el-option v-for="item in pieceUnitCodeOpts" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </div>

      <div style="margin: 6px 0px" v-if="row.productSkuMultiPack.skuClassification != 1">
        <el-select v-model="row.productSkuMultiPack.individuallyPacked" placeholder="请选择">
          <el-option v-for="item in individuallyPackedOpts" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </div>
    </template>
    <template slot="productSkuAccessoriesSlot" slot-scope="{ row, $index }">
      <div style="margin: 6px 0px" v-for="(accessorie, idx) in row.productSkuAccessories" :key="accessorie.vid + idx">
        <el-select
          :value="accessorie"
          value-key="vid"
          name-key="value"
          placeholder="请选择"
          style="width: 90px"
          filterable
          remote
          :remote-method="accessorieVidRemoteMethod"
          @change="e => accessorieVidChange(e, idx, $index)"
          @focus="accessorieFocus"
        >
          <el-option
            v-for="item in accessorieVidOpts"
            :key="item.vid"
            :label="item.value"
            :value="item"
            :disabled="isVidOptDisabled(item.vid, row.productSkuAccessories)"
          ></el-option>
        </el-select>
        <el-input-digit v-model.number="accessorie.num" placeholder="数量" format="#" style="width: 60px">
          <span>{{ accessorie.unitName }}</span>
        </el-input-digit>
        <el-button type="link" :disabled="row.productSkuAccessories.length === 1" @click="deleteAccessories(idx, row.productSkuAccessories)"
          ><i class="el-icon-delete"></i
        ></el-button>
      </div>
      <div>
        <el-button type="link" @click="addAccessories(row.productSkuAccessories)"> + 添加</el-button>
      </div>
    </template>
  </FormItemSkuList>
</template>
<script>
import FormItemSkuList from '../../FormItemSpecification/FormItemSkuList.vue';
import InputDigitComb from '@/components/prod/center/components/FormItemSpecification/components/InputDigitComb.vue'
import SearchSelectComb from '@/components/prod/center/components/SearchSelectComb.vue'
import { getGoodsAccessories } from '@/servers/prod/center/temu.js';
import { skuClassificationOpts, pieceUnitCodeOpts, individuallyPackedOpts,CURRENCY_MAP } from '../config';
import {
  defaultProductSkuSuggestedPrice,
  defaultProductSkuUsSuggestedPrice,
  defaultProductSkuMultiPack,
} from '@/servers/prod/center/temu.js';
import { skcExtCodeReg } from '../rules.js'
import { cloneDeep } from 'lodash';

const defaultBatchValues = {
  productSkuSuggestedPrice: cloneDeep(defaultProductSkuSuggestedPrice),
  productSkuUsSuggestedPrice: cloneDeep(defaultProductSkuUsSuggestedPrice),
  productSkuMultiPack:cloneDeep(defaultProductSkuMultiPack),
  // extCode:''
};
export default {
  model: {
    prop: 'skuList',
    event: 'change',
  },
  components: { FormItemSkuList,InputDigitComb,SearchSelectComb },
  props: {
    specifications: {
      type: Array,
      default() {
        return [];
      },
    },
    skuList: {
      type: Array,
      default() {
        return [];
      },
    },
    showImgCol: Boolean,
    baseItemId: [String, Number],
    shopId: [String, Number],
    skcSpec:{
      type:null/Object,
      default(){
        return null
      }
    }
  },
  data() {
    return {
      CURRENCY_MAP,
      skuImgOnlyPreview: true,
      skuClassificationOpts,
      pieceUnitCodeOpts,
      individuallyPackedOpts,
      curSkulist: [],
      accessorieVidOpts: [],
      defaultAccessorieVidOpts: [],
      batchValues: cloneDeep(defaultBatchValues),
      barCodeList:[
        {
          label:'EAN',
          value:'EAN'
        },
        {
          label:'UPC',
          value:'UPC'
        },
        {
          label:'ISBN',
          value:'ISBN'
        },
      ],
      isChange: false,
      errorMsg: '',
    };
  },
  computed:{
    skuTableCols(){
      return [
        {
          prop: 'supplierPrice',
          attrs: { label: '申报价格(CNY)', width: 120 },
          input: { type: 'number' },
          slot: true,
        },
        {
          prop: 'productSkuSuggestedPrice',
          attrs: { label: '建议零售价', width: 180 },
          input: { },
          slot: true,
          // headerSlot: true,
          isBatchSlot:true,
        },
        {
          prop: 'productSkuUsSuggestedPrice',
          attrs: { label: '制造商建议零售价', noRequired:true,width: 180 },
          input: { },
          isBatchSlot:true,
          slot: true,
        },
        {
          prop: 'productSkuMultiPack',
          attrs: { label: 'SKU分类', width: 190 },
          input: { },
          isBatchSlot:true,
          slot: true,
        },
        this.skcSpec ? null : { prop: 'productSkuBarCodeReqs', attrs: { label: '商品编码', width: 220,noRequired: true,headerTooltip:'以上编码为国际通用的商品编码，用于标识和识别不同的商品，包括统一产品编码（UPC）、欧洲商品编码（EAN）、国际标准书号（ISBN）。其中，UPC主要用于美国和加拿大，其他大多数国家/地区通常使用EAN识别商品。如果您的商品已经有国际通用的商品编码，您可以填写该编码，以便更好地管理和跟踪您的商品。' }, input: {onlyTable: true },slot: true },
        { prop: 'outId', attrs: { label: '基础资料商家编码', width: 160, headerTooltip: '必填，用于关联基础资料规格明细' }, input: { type: 'text', onlyTable: true } },  
        // { prop: 'stock', attrs: { label: '库存', width: 140 }, input: { type: 'number' } },
        { prop: 'extCode', attrs: { label: 'sku货号', noRequired: true, width: 140  }, input: { type: 'text'} },
        { prop: 'productSkuAccessories', attrs: { label: '包装清单', noRequired: true, width: 200 }, slot: true },
      ].filter(Boolean)
    },
    currencyList(){
      return Object.values(CURRENCY_MAP)
    },
    productSkuMultiPackBatchSetValue(){
      let skuClassification = this.batchValues.productSkuMultiPack.skuClassification
      let numberOfPieces = this.batchValues.productSkuMultiPack.numberOfPieces
      let pieceUnitCode = this.batchValues.productSkuMultiPack.pieceUnitCode
      let individuallyPacked = this.batchValues.productSkuMultiPack.individuallyPacked
      let result = []
      if(skuClassification){
        let obj = this.skuClassificationOpts.find(i => i.value === skuClassification )
        result.push(obj.label)
      }
      if(numberOfPieces){
        let obj = this.pieceUnitCodeOpts.find(i => i.value === pieceUnitCode ) || {}
        result.push(numberOfPieces+(obj.label || ''))
      }
      if(typeof individuallyPacked === 'number'){
        let obj = this.individuallyPackedOpts.find(i => i.value === individuallyPacked )
        result.push(obj.label)
      }
      return result.join('、')
    }
  },
  watch: {
    skuList: {
      handler(v) {
        // if (this.isChange) {
        //   this.isChange = false;
        //   return;
        // }
        this.curSkulist = cloneDeep(v);
      },
      deep: true,
      immediate: true,
    },
    curSkulist: {
      handler(v) {
        // this.isChange = true;
      },
      deep: true,
    },
  },
  methods: {
    skuListChange(v){
        this.$emit('change', cloneDeep(v));
        // this.$emit('change', cloneDeep(this.curSkulist));
        this.$emit('fieldChanged');
    },
    skuClassificationChange(v, row) {
      if (v == 1) {
        row.productSkuMultiPack.numberOfPieces = 1;
      } else if (v == 2) {
        row.productSkuMultiPack.individuallyPacked = 1;
      }
    },
    isVidOptDisabled(vid, selectedList) {
      return selectedList.some(item => item.vid === vid);
    },
    async getAccessoriesData(queryText) {
      const res = await getGoodsAccessories({ shopId: this.shopId, pageNo: 1, pageSize: 20, fuzzyValue: queryText || '' });
      return res;
    },
    accessorieVidChange(v, idx, $index) {
      const oldVal = this.curSkulist[$index].productSkuAccessories[idx];
      this.$set(this.curSkulist[$index].productSkuAccessories, idx, { ...v, num: oldVal.num });
    },
    async accessorieVidRemoteMethod(queryText) {
      if (queryText) {
        this.accessorieVidOpts = await this.getAccessoriesData(queryText);
      }
    },
    accessorieFocus() {
      this.accessorieVidOpts = cloneDeep(this.defaultAccessorieVidOpts);
    },
    deleteAccessories(index, list) {
      list.splice(index, 1);
    },
    addAccessories(list) {
      list.push({
        vid: '',
        value: '',
        num: '',
        unitCode: '',
        unitName: '',
      });
    },

    batchUpdateSku() {
      const batchList = this.$refs.formItemSkuListRef.getNeedBatchList();
      const targetSkuIds = new Set(batchList.map(item => item._skuid));
      const renderList = cloneDeep(this.$refs.formItemSkuListRef.renderList);
      let props = Object.keys(this.batchValues)
      const newRenderList = renderList.map(item => {
        if (targetSkuIds.has(item._skuid)) {
          let c_sku = this.curSkulist.find(csku => csku._skuid === item._skuid)
          props.forEach(prop => {
            let v = cloneDeep(this.batchValues[prop]);
            this.$set(c_sku,prop,v)
          })
        }
        return item;
      });
      this.$refs.formItemSkuListRef.setRenderList(newRenderList);
      props.forEach(prop => {
          this.$set(this.batchValues, prop, cloneDeep(defaultBatchValues[prop]));
      })
    },
    // 校验skuList
    validate() {
      let errorMsg = '';
      const findErrRow = this.curSkulist.find(row => {
        if (!row.outId) {
          errorMsg = '请绑定商家编码';
        } else if (row.extCode && !skcExtCodeReg.test(row.extCode)) {
          errorMsg = '请使用字母、数字和标点符号维护 sku货号';
        } else if (!row.supplierPrice) {
          errorMsg = '请输入大于0的申报价格';
        } else if (
          !row.productSkuSuggestedPrice.suggestedPriceStr ||
          !/^(NA|([1-9]\d*(\.\d{1,2})?|0\.[1-9]\d?|0\.0[1-9]))$/.test(row.productSkuSuggestedPrice.suggestedPriceStr)
        ) {
          errorMsg = '【建议零售价】只能输入大于0的数字（最多两位小数）或输入“NA”';
        } else if (!row.productSkuMultiPack?.skuClassification) {
          errorMsg = '请选择商品分类';
        } else if (row.productSkuMultiPack?.skuClassification == 2 && row.productSkuMultiPack?.numberOfPieces == 1) {
          errorMsg = '单品数量等于1请改为单品';
        } else if ([2, 3].includes(row.productSkuMultiPack?.skuClassification) && !row.productSkuMultiPack?.numberOfPieces) {
          errorMsg = '请输入单品数量';
        }
        return !!errorMsg;
      });
      if (findErrRow) {
        let skuSvalues = [];
        this.specifications.forEach(s => {
          const value = findErrRow.skuSpecifications.find(skuS => skuS.name === s.name).value;
          skuSvalues.push(value);
        });
        errorMsg = `【 ${skuSvalues.join(' + ')} 】：` + errorMsg;
      }
      return errorMsg;
    },
  },
  async mounted() {
    const res = await this.getAccessoriesData();
    this.defaultAccessorieVidOpts = res;
  },
};
</script>

<style lang="scss">
</style>